/**
 * Butikens bilder i rätt storlek. Bilderna i Supabase Storage är ofta
 * originalfoton på flera MB, men visas som kort på några hundra pixlar.
 * Vercels bildtjänst (/_vercel/image, inställd i vercel.json) gör en mindre
 * WebP-version och sparar den, så att Supabase skickar varje bild ungefär en
 * gång i stället för vid varje besök. Ingen bild i databasen ändras.
 */

/** Bredderna som vercel.json tillåter (images.sizes). Måste vara samma lista. */
export const IMAGE_WIDTHS = [128, 256, 640, 1080, 1600] as const;
export type ImageWidth = typeof IMAGE_WIDTHS[number];

/** Bara publika filer i projektets egen Storage (vercel.json: images.remotePatterns). */
const STORAGE_PREFIX = 'https://safpfosbbrqmexlhjrth.supabase.co/storage/v1/object/public/';

const QUALITY = 75;

/** Bildtjänsten finns bara på Vercel, inte lokalt (vite dev/preview). */
const onVercel = (): boolean => {
    if (typeof window === 'undefined') return false;
    const host = window.location.hostname;
    return host !== 'localhost' && host !== '127.0.0.1' && !host.endsWith('.local');
};

/**
 * Adressen till en förminskad version av bilden, eller originalet om bilden
 * inte ligger i projektets Storage (t.ex. en extern bild) eller om sidan inte
 * körs på Vercel.
 */
export const optimizedImageUrl = (url: string | null | undefined, width: ImageWidth, enabled: boolean = onVercel()): string => {
    const src = (url ?? '').trim();
    if (!enabled || !src.startsWith(STORAGE_PREFIX)) return src;
    return `/_vercel/image?url=${encodeURIComponent(src)}&w=${width}&q=${QUALITY}`;
};
